import { useLocation } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import FormGenerator from "../../plugins/formGenerator/form";

export default function Customer() {
  return (
    <>
      <PageMeta title="TTM Add Carriers | Admin Carriers" description="" />
      <div>
        <FormGenerator formId="customer" />
      </div>
    </>
  );
}
